var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4417 16.5584L11.4417 10.5584C12.1 9.70837 12.4917 8.65003 12.4917 7.4917C12.4917 4.73337 10.25 2.4917 7.4917 2.4917C4.73337 2.4917 2.4917 4.73337 2.4917 7.4917C2.4917 10.25 4.73337 12.4917 7.4917 12.4917C8.65003 12.4917 9.70837 12.1 10.5584 11.4417L16.5584 17.4417L17.4417 16.5584ZM7.50003 11.25C5.43337 11.25 3.75003 9.5667 3.75003 7.50003C3.75003 5.43337 5.43337 3.75003 7.50003 3.75003C9.5667 3.75003 11.25 5.43337 11.25 7.50003C11.25 9.5667 9.5667 11.25 7.50003 11.25Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search_Icon.02a3b482003e1367e86491e50766b56b.svg";